import * as React from "react"
import PowerIcon from "../../atoms/icons/PowerIcon"
import SettingsOverviewCard from "../../molecules/SettingsOverviewCard"
import ReadOnlyTextField from "../../molecules/card/ReadOnlyTextField"
import { useEdgeApi } from "../../../edge/EdgeProvider"
import { VOLTAGE_FLOAT_DECIMAL_COUNT } from "../../constants"
import { SECTION_SYSTEM_LNB_METRICS } from "../../../utils/pages"

const LnbMetricsCard: React.FunctionComponent = () => {
  const { metrics } = useEdgeApi()

  const displayVoltage = (voltage?: number) =>
    voltage ? `${voltage.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} V` : undefined

  const displayCurrent = (current?: number) =>
    current ? `${current.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} A` : undefined

  const displayTemperature = (temp?: number) => (temp ? `${temp.toFixed(VOLTAGE_FLOAT_DECIMAL_COUNT)} °C` : undefined)

  return (
    <SettingsOverviewCard title={SECTION_SYSTEM_LNB_METRICS.name} icon={<PowerIcon />}>
      <ReadOnlyTextField
        placeholder="-.- °C"
        label="Temp sensor 1"
        value={displayTemperature(metrics.useLnbTelemetriesTempSensor1())}
      />
      <ReadOnlyTextField
        placeholder="-.- °C"
        label="Temp sensor ctrl"
        value={displayTemperature(metrics.useLnbTelemetriesTempSensorCtrl())}
      />
      <ReadOnlyTextField
        placeholder="-.- V"
        label="Voltage"
        value={displayVoltage(metrics.useLnbTelemetriesVoltage())}
      />
      <ReadOnlyTextField
        placeholder="-.- A"
        label="Current"
        value={displayCurrent(metrics.useLnbTelemetriesCurrent())}
      />
    </SettingsOverviewCard>
  )
}

export default LnbMetricsCard
